import { VFC, useMemo } from 'react';
import { WaterMeterMeasurementType } from '@enmon/commons';
import { FormattedMessage, useIntl } from 'react-intl';
import { Select } from '../../Select';
import { SelectMessages as messages } from '../../messages';
import { waterMeterMeasurementTypeTranslated } from '../../../Form/meter_details/constants';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';

interface WaterMeterMeasurementTypeSelectProps {
  value?: WaterMeterMeasurementType;
  onChange?: (value: WaterMeterMeasurementType) => void;
}

export const WaterMeterMeasurementTypeSelect: VFC<WaterMeterMeasurementTypeSelectProps> = ({
  ...restProps
}: WaterMeterMeasurementTypeSelectProps) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const waterMeterMeasurementTypeOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(WaterMeterMeasurementType),
        suggestedValue: meterModelSuggestions?.measurementType?.value,
        suggestedSelection: meterModelSuggestions?.measurementType?.selection,
        labelFormatter: (value: WaterMeterMeasurementType) =>
          intl.formatMessage(waterMeterMeasurementTypeTranslated[value]),
      }),
    [meterModelSuggestions, intl],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={waterMeterMeasurementTypeOptions}
      placeholder={<FormattedMessage {...messages.measurementTypeSelect} />}
      {...restProps}
    />
  );
};
